export default {
    'Login.title':'欢迎来到SlidesOrator',
    'Login.stitle':'我们建议使用工作电子邮件与您的团队轻松协作',
    'Login.EmailText': '手机号登录',
    'Login.captcha':'登录/注册',
    'Login.getCode':'获取验证码',
    'Login.resCode':'重新发送', 
    'Login.captchaPlaceholder':'验证码',
    'Login.EmailPlaceholder':'请输入邮箱',
    'Login.EmailError':'邮箱输入有误',
    'Login.codeError':'请输入6位验证码',
    'Login.succeeded':'登录成功',
    'Login.sentCodeSucceeded':'验证码发送成功',
    'Login.registerSucceeded':'注册成功',
    'Login.register.placeholder':'输入密码',
    'Login.register.placeholder2':'再次输入密码',
    'Login.register.passErr1':'密码长度为 6 到 16 位，必须包含大写、小写字母和数字',
    'Login.register.passErr2':'密码不一致',
  };

